import script from "./DocItemSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./DocItemSelect.vue?vue&type=script&setup=true&lang=js"

import "./DocItemSelect.vue?vue&type=style&index=0&id=026f6974&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-026f6974"]])

export default __exports__